import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { Context } from 'hono'

/**
 * Standalone action - Restart Server
 *
 * Gracefully restarts the Nexus server process.
 * Protected by: CASL (ADMIN only) + simple confirmation
 */
export const restartServerAction: ActionDefinition = {
  key: 'restart-server',
  scope: 'module',
  group: { en: 'System', es: 'Sistema' },
  label: { en: 'Restart Server', es: 'Reiniciar Servidor' },
  icon: 'mdi:restart',
  variant: 'danger',

  confirm: {
    type: 'simple',
    title: { en: 'Restart Server', es: 'Reiniciar Servidor' },
    message: {
      en: 'The server will restart. All active connections will be dropped momentarily.',
      es: 'El servidor se reiniciará. Todas las conexiones activas se interrumpirán momentáneamente.'
    },
    confirmText: { en: 'Restart', es: 'Reiniciar' },
    severity: 'warning'
  },

  handler: async (ctx, _input, c?: Context<any>) => {
    const user = c?.get('user') as { id?: string } | undefined
    const userId = user?.id ?? 'unknown'
    const fwd = c?.req.header('x-forwarded-for')
    const ip = fwd?.split(',')[0]?.trim() || c?.req.header('x-real-ip')
    const userAgent = c?.req.header('user-agent')
    ctx.core.logger.warn({ userId }, 'Server restart initiated')

    ctx.events.notify('audit.log', {
      source: 'core:system',
      action: 'server_restart',
      actorId: user?.id,
      ip,
      userAgent
    })

    // Schedule exit after response is sent
    setTimeout(() => process.exit(0), 500)

    return { success: true, message: 'Server is restarting...' }
  },

  casl: {
    subject: 'SystemManagement',
    permissions: {
      ADMIN: { actions: ['execute'] }
    }
  }
}
